import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const ErrorWrapper = styled.div`
    text-align: center;
    margin-top: auto;
    margin-bottom: auto;
`;

export const ErrorMessage = styled.div.attrs({ role: 'alert' })`
    display: inline-block;
    padding-top: ${getPurpurSpacing('200')};
    padding-bottom: ${getPurpurSpacing('200')};
    padding-left: ${getPurpurSpacing('400')};
    padding-right: ${getPurpurSpacing('400')};
    background-color: ${getPurpurColor('red500')};
    color: ${getPurpurColor('functionalWhite')};
    margin-bottom: ${getPurpurSpacing('300')};
`;
